@if (embedUrl) {
  <iframe
    id="bigBlueButtonContainer"
    [src]="embedUrl"
    (load)="onIframeLoad()"
    allowfullscreen
    width="100%"
    height="100%"
    allow="camera; microphone; encrypted-media; autoplay;"
    title="BigBlueButton"
  ></iframe>
}

@if (!embedUrl) {
  <div class="join-conference-wrapper">
    <div class="join-conference-boat">
      @if (statusMessage) {
        <div [@else]="joinMeetingPrompt" class="join-conference-prompt">
          <h4 [innerHTML]="statusMessage"></h4>
        </div>
      }
      <ng-template #joinMeetingPrompt>
        <div class="join-conference-prompt">
          <h3>{{'BigBlueButton Conference' | translate}}</h3>
          <button type="button" (click)="joinConference()" class="btn btn-primary btn-large">
            {{'Join Conference' | translate}}
          </button>
        </div>
      </ng-template>
    </div>
  </div>
}
